export const getToken = () =>
  localStorage.getItem('adminToken') ||
  sessionStorage.getItem('adminToken') ||
  localStorage.getItem('token') ||
  sessionStorage.getItem('token');

export const setToken = (token, remember = true) => {
  localStorage.removeItem('adminToken');
  sessionStorage.removeItem('adminToken');
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
  if (remember) {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('token', token);
  } else {
    sessionStorage.setItem('adminToken', token);
    sessionStorage.setItem('token', token);
  }
};

export const removeToken = () => {
  localStorage.removeItem('adminToken');
  sessionStorage.removeItem('adminToken');
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
};

export const clearAuthData = () => {
  removeToken();
  ['token', 'adminToken', 'adminEmail', 'adminRemember', 'role', 'adminLoginData'].forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};
